import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  pulse = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-extrabold rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-dark overflow-hidden cursor-pointer select-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-gradient-to-r from-brand-indigo via-indigo-500 to-brand-indigo text-white hover:from-indigo-500 hover:via-indigo-400 hover:to-indigo-500 shadow-[0_6px_30px_rgba(67,56,202,0.45)] hover:shadow-[0_8px_45px_rgba(67,56,202,0.65)]',
    secondary: 'bg-gradient-to-r from-brand-amber via-yellow-600 to-brand-amber text-white hover:from-amber-500 hover:via-yellow-500 hover:to-amber-500 shadow-[0_6px_30px_rgba(217,119,6,0.3)] hover:shadow-[0_8px_45px_rgba(217,119,6,0.5)]',
    outline: 'border-2 border-slate-300 text-slate-300 hover:bg-slate-800 hover:text-white hover:border-slate-800'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-7 py-3.5 text-base',
    lg: 'px-9 py-4 text-lg',
    xl: 'px-12 py-6 text-xl'
  };
  const pulseClass = pulse ? 'animate-glow-pulse' : '';
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.96
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 15
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${pulseClass} ${widthClass} ${className}`} {...props} data-id="element-394">
      {/* Shine sweep */}
      <span className="absolute inset-0 overflow-hidden rounded-full pointer-events-none" data-id="element-395">
        <span className="absolute -left-full top-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg] animate-[shine_2.5s_ease-in-out_infinite]" data-id="element-396" />
      </span>
      {/* Top edge highlight */}
      <span className="absolute inset-x-0 top-0 h-[2px] bg-white/25 rounded-full pointer-events-none" data-id="element-397" />
      {/* Bottom edge depth */}
      <span className="absolute inset-x-0 bottom-0 h-[2px] bg-black/15 rounded-full pointer-events-none" data-id="element-398" />
      <span className="relative z-10 flex items-center justify-center gap-1 drop-shadow-sm" data-id="element-399">
        {children}
      </span>
    </motion.button>;
}